import { render, staticRenderFns } from "./productSpec.vue?vue&type=template&id=a67c4a34&scoped=true&"
import script from "./productSpec.vue?vue&type=script&lang=js&"
export * from "./productSpec.vue?vue&type=script&lang=js&"
import style0 from "./productSpec.vue?vue&type=style&index=0&id=a67c4a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c4a34",
  null
  
)

export default component.exports